import ConfigurationController from './configuration.controller';

export default {
    bindings: {
        close: '&'
    },
    controller: ConfigurationController,
    template: require('./configuration.tpl.html')
};
